module.exports = __webpack_public_path__ + "static/media/icn_diamond_pin_green_merge.0c8788f7.svg";